<template>
  <div class="flex align-items-center">
    <InputText
      v-model="value"
      class="input-text"
      title=""
    />
  </div>
</template>

<script lang="ts">
import {
  defineComponent, ref, SetupContext, watch,
} from 'vue';
import InputText from 'primevue/inputtext';

export default defineComponent({
  name: 'SegmentInputText',

  components: {
    InputText,
  },

  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },

  emits: ['update:modelValue'],

  setup(props: { modelValue: string }, { emit }: SetupContext) {
    const value = ref(props.modelValue);

    watch(value, () => {
      emit('update:modelValue', value.value);
    });

    return {
      value,
    };
  },
});
</script>

<style lang="scss" scoped>
.input-text {
  font-size: 1.25rem !important;
  padding: 0.625rem 0.625rem !important;
}
</style>
